module.exports = __webpack_public_path__ + "img/A01-20040015-001.de0387d3.jpg";